import { IconName } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Text } from "grommet";
import * as React from "react";
import GenericErrorBoundary from "../general/GenericErrorBoundary";
import { StatViewModel } from "../stats/StatsStore";

const fa = (icon) => (color) => <FontAwesomeIcon icon={["fad", icon]} color={color}></FontAwesomeIcon>;

export function StatIcon(stat: StatViewModel) {
    if (!stat || !stat.icon) return fa("dash")(StatColor(stat));

    return fa(stat.icon)(StatColor(stat));
}

export function StatColor(stat: StatViewModel) {
    if (!stat) return "";

    return stat.color;
}

export const Stat = ({ stat, disabled, includeText, onClick, children }: { stat: StatViewModel; disabled: boolean; includeText?: boolean; onClick?: Function; children?: any }) => {
    let icon = StatIcon(stat);

    let BoxProps = !disabled && onClick ? { hoverIndicator: "background-back", onClick: () => onClick && onClick() } : {};
    return (
        <Box direction={"row"} background={"background-front"} pad="small" gap="small" round="10px" title={stat.name} {...BoxProps} align="center">
            <GenericErrorBoundary>{icon}</GenericErrorBoundary>
            {includeText && <Text>{stat.name}</Text>}
            {children}
        </Box>
    );
};
